import React from 'react'

import CommonViewPeople from './common/viewPeople'

const ViewPeople: React.FC = (props) => {
  return <CommonViewPeople />
}

export default ViewPeople
